import {
  doc,
  collection,
  query,
  where,
  orderBy,
  getDoc,
  getDocs,
  addDoc,
  setDoc,
  updateDoc,
  deleteDoc,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from './config';

const COLLECTION = 'przekrojProjects';

/**
 * Zwraca liste projektow zalogowanego uzytkownika, posortowana od ostatnio modyfikowanych.
 */
export const getUserProjects = async (userId) => {
  const q = query(
    collection(db, COLLECTION),
    where('ownerId', '==', userId),
    orderBy('updatedAt', 'desc'),
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
};

/**
 * Pobiera pojedynczy projekt po ID. Zwraca null jesli nie istnieje.
 */
export const getProject = async (projectId) => {
  const ref = doc(db, COLLECTION, projectId);
  const snap = await getDoc(ref);
  if (!snap.exists()) return null;
  return { id: snap.id, ...snap.data() };
};

/**
 * Tworzy nowy projekt. Zwraca ID utworzonego dokumentu.
 */
export const createProject = async (userId, name, data = {}) => {
  const ref = await addDoc(collection(db, COLLECTION), {
    ownerId: userId,
    name,
    data,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  return ref.id;
};

/**
 * Zapisuje dane projektu (merge) i aktualizuje updatedAt.
 */
export const saveProject = async (projectId, data) => {
  const ref = doc(db, COLLECTION, projectId);
  await setDoc(
    ref,
    {
      data,
      updatedAt: serverTimestamp(),
    },
    { merge: true },
  );
};

/**
 * Zmienia nazwe projektu.
 */
export const renameProject = async (projectId, name) => {
  const ref = doc(db, COLLECTION, projectId);
  await updateDoc(ref, {
    name,
    updatedAt: serverTimestamp(),
  });
};

/**
 * Usuwa projekt.
 */
export const deleteProject = async (projectId) => {
  const ref = doc(db, COLLECTION, projectId);
  await deleteDoc(ref);
};
